import { REPORT_STATUS, ASSIGNMENT_STATUS } from '../Helpers/format';

/**
 * Colour-coded status pill.
 * kind="report" (default) uses report statuses; kind="assignment" uses assignment statuses.
 */
const StatusPill = ({ status, kind = 'report', className = '' }) => {
  const map = kind === 'assignment' ? ASSIGNMENT_STATUS : REPORT_STATUS;
  const entry = map[status] || { label: status || '—', tone: 'draft' };
  return (
    <span className={`pm-pill pm-pill--${entry.tone} ${className}`.trim()} title={entry.label}>
      {entry.label}
    </span>
  );
};

export { StatusPill };
export default StatusPill;
